import { render, staticRenderFns } from "./MyPackages.vue?vue&type=template&id=7775fe61&scoped=true&"
import script from "./MyPackages.vue?vue&type=script&lang=js&"
export * from "./MyPackages.vue?vue&type=script&lang=js&"
import style0 from "./MyPackages.vue?vue&type=style&index=0&id=7775fe61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7775fe61",
  null
  
)

export default component.exports